import { SiteArticleHeaderShareWrapper1280 } from "../../componentas/articleHeaderComponenta/siteArticleHeaderShareWrapper1280";
import { ArticleData } from "../../../../../articlePage/stateInterfaces"
import { SimpleLinkRenderer } from "../../../../commonComponents/inline/hyperLink"
import { RenderReactAtSite } from "../../../../commonComponents/inline/renderReactAtSite";
import { AccessebilityButton } from "./articleMagazineNagishButton";
import { ArticleMagazineTopStoryData } from "../articleMagazineTopStoryData";
import { hexToRgbA } from "../../../../widgetsUtils";
import { useState, useEffect } from "react";

export function HeaderScrollWatcher() {
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setIsScrolled(window.scrollY > 0);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        const header = document.querySelector(".article-magazine-top-story-header") as HTMLElement;
        if (!header) return;
        const color = header.getAttribute("data-color") || "#1E1E1E";
        if (!color || color === "#1E1E1E") return;
            header.style.backgroundColor = hexToRgbA(color, isScrolled ? "1" : "0.75");
    }, [isScrolled]);

    return null;
}
(HeaderScrollWatcher as any).siteScriptName = "HeaderScrollWatcher";

interface ArticleMagazineTopStoryHeaderProps {
    data: ArticleData
    widgetType: string
}
export class ArticleMagazineTopStoryHeader extends React.Component<ArticleMagazineTopStoryHeaderProps, {}> {   
    

    render() {
        const { widgetType, data } = this.props
        const magazineTopStoryData = data.topStoryData[widgetType] as ArticleMagazineTopStoryData;
        const addClass = magazineTopStoryData.itemColor && magazineTopStoryData.itemColor !== "#1E1E1E" ?  hexToRgbA(magazineTopStoryData.itemColor, "0.75") : "#1E1E1E";

        return (
            <><div className="article-magazine-top-story-header" style={{ backgroundColor: addClass }} data-color={magazineTopStoryData.itemColor || "#1E1E1E"} >
               <SimpleLinkRenderer className="logo" href={"/"}></SimpleLinkRenderer>
                <div className="share-container">
                    <SiteArticleHeaderShareWrapper1280
                        lang={"he"}
                        articleId={data.articleId}
                        title={data.title}
                        categorySubChannel={data.subchannelName && data.subchannelName.toString()}
                        author={data.authors[0] ? data.authors[0].name : ""}
                        showComments={false}
                        isSpotim={false}
                    />
                   
                </div>
            </div><RenderReactAtSite><HeaderScrollWatcher /></RenderReactAtSite>
            <RenderReactAtSite><AccessebilityButton /></RenderReactAtSite></>
        )
    }
}
